const fonts: string[] = [
  'https://fonts.googleapis.com/css2?family=Sarabun:wght@200;300;400;500;600;700&display=swap'
  // 'https://fonts.googleapis.com/css2?family=Prompt:wght@100;200;300;400;500;600&display=swap'
];
export default fonts;
